export default {"src":"/_next/static/media/basket.b8dad09a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};